import * as React from "react";
import { Toolbar, SaveButton, ToolbarProps } from "react-admin";
import { Button } from "@mui/material";

export const DialogFormToolbar: React.FC<
  ToolbarProps & { onCancel: () => void }
> = (props) => {
  const { onCancel, ...raProps } = props;
  return (
    <Toolbar {...raProps}>
      <SaveButton alwaysEnable />
      <Button onClick={onCancel} sx={{ ml: 2 }}>
        Annuler
      </Button>
    </Toolbar>
  );
};
